import React, { useState, useEffect } from 'react'
import { CForm, CFormInput, CButton, CFormTextarea, CTooltip, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CSpinner } from '@coreui/react'
import ProviderPatientAllergies from './ProviderAllergies'
import ProviderHistoryAddModal from './ProviderHistoryAddModal'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import { Plus, X, FileText, Check, Trash, Pencil } from 'lucide-react'
import { Upload } from 'lucide-react'
import PatientReportCRUD from '../../services/general/patientReportCrud.api'
import CloudinaryUploader from '../../components/shared/CloudinaryUploader'
import PatientPastNote from './PatientPastNote'
import ProviderHistoryAddModalTest from './ProviderAddHistoryAddModalTest'

const ProviderPatientHistoryTest = ({
  hospitalRecords,
  handleAddHistoryToggle,
  patientTreatments,
  loggedUserProvider,
  noteID,
  viewPatientDetail,
  showAllNotes,
  getPatientHistory,
  AddHistoryToggle,
  showDataIfNoteIsFollowUp,
  setAddHistoryToggle,
  noteStructureRef,
  personalHistory,
  saveTreatsShell,
  patientID,
  loading,
  setHistories,
  setLoading,
  allergiesList,
  setAllergiesList,
  patientDBData,
  setPatientDBData,
}) => {
  console.log(personalHistory, 'personalHistory')

  const historyMapping = {
    pmhx: 'Past Medical History',
    pshx: 'Past Surgical History',
    fh: 'Family History',
    sh: 'Social History',
  }

  const historyObjectKeysParticular = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous']
  const [visible, setVisible] = useState(false)
  const [modeReport, setModeReport] = useState('')
  const [fileBase64, setFileBase64] = useState('')
  const [viewer, setViewer] = useState(false)
  const [selectedFileViewBase64, setSelectedFileViewBase64] = useState('')
  const [reportData, setReportData] = useState({
    Labs: [],
    Medication: [],
    Imaging: [],
    Miscellaneous: [],
  })
  const [file, setFile] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(false)

  const handleFileUpload = (event) => {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setFileBase64(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const toggleModal = (mode) => {
    // if (visible) {
    //   setVisible(false);
    //   setModeReport('');
    //   setFileBase64('');
    // } else {
    //   setVisible(true);
    //   setModeReport(mode);
    // }
    setModeReport(mode)
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  // const fetchReports = async () => {
  //   setIsPageLoading(true)
  //   for (const sections of threeSections) {
  //     let formattedData
  //     formattedData = await PatientReportCRUD('GET', patientID.toString(), '', sections.toString())

  //     if (formattedData) {
  //       formattedData = JSON.parse(formattedData.d)?.Data
  //       formattedData = formattedData.map((item) => {
  //         return {
  //           ...item,
  //           data: JSON.parse(item.data),
  //         }
  //       })
  //     }

  //     console.log(formattedData, 'formattedData')
  //     setReportData((p) => ({
  //       ...p,
  //       [sections]: formattedData,
  //     }))
  //   }
  //   setIsPageLoading(false)
  // }

  // useEffect(() => {
  //   fetchReports()
  // }, [])

  console.log(reportData, 'reportData')
  const handleSubmit = async (mediaData) => {
    const jsonFormat = JSON.stringify(mediaData)

    await PatientReportCRUD('INSERT', patientID.toString(), '', modeReport.toString(), jsonFormat, getFormattedDate().toString())
    setModeReport('')
    setFileBase64('')
    // setFile([]);

    setVisible(false)
    await fetchReports()
  }

  const handleDeleteFileData = async (id) => {
    await PatientReportCRUD('DELETE', patientID.toString(), id)
    await fetchReports()
  }
  const handleViewFile = (file) => {
    setSelectedFileViewBase64(file)
    setViewer(true)
  }

  const handleDeleteFile = (id) => {
    setFile((prevFiles) => {
      if (prevFiles.length === 1) return []
      return prevFiles.filter((item, i) => item.id !== id)
    })
  }

  const handleCloudinaryUpload = (url, type, fileName, id, publicId) => {
    setFile((prevFiles) => {
      const isDuplicate = prevFiles.some((file) => file.url === url)
      if (isDuplicate) return prevFiles
      handleSubmit([{ url, type, fileName, id, publicId }])
      return [...prevFiles, { url, type, fileName, id, publicId }]
    })
    // setTimeout(()=>(handleSubmit,2000))
  }
  const keyLabels = {
    pmhx: 'Past Medical History',
    pshx: 'Past Surgical History',
    fh: 'Family History',
    sh: 'Social History',
  }

  return (
    <div className="d-flex flex-column gap-2">
      {/* Hospital Records */}
      {/* <CAccordion >
                <CAccordionItem itemKey={1}>
                    <CAccordionHeader>Hospital Records</CAccordionHeader>
                    <CAccordionBody>
                        {hospitalRecords.filter(item => item.Id === noteStructureRef.current?.metadata?.historyId).map((record, index) => {
                            const rows = Math.max(4, Math.ceil(record.History.length / 50));
                            return (
                                <>
                                    <div
                                        contentEditable
                                        suppressContentEditableWarning={true}
                                        className="my-1"
                                        style={{ whiteSpace: 'pre-line' }}
                                    >
                                        {record.History}
                                    </div>
                                </>
                            )
                        })}

                    </CAccordionBody>
                </CAccordionItem>
            </CAccordion> */}

      <span>
        <CButton
          variant="outline"
          size="sm"
          onClick={() => {
            handleAddHistoryToggle()
          }}
          style={{
            background: '#4363F2',
            color: 'white',
          }}
        >
          Add History
        </CButton>
      </span>
      {console.log(personalHistory, 'histories===>')}
      {!showDataIfNoteIsFollowUp && (
        <CAccordion alwaysOpen className="d-flex flex-column gap-2">
          {/* {Object.entries(personalHistory).map(([key, histories], index) => {
            console.log(histories, personalHistory, noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]], 'noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]]')
            return (
              <CAccordionItem className="border" itemKey={index}>
                <CAccordionHeader>{historyMapping[key]}</CAccordionHeader>
                <CAccordionBody className="d-flex flex-column gap-3">
                  {histories
                    .filter((item) => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]])
                    .map((item, index) => (
                      // {histories?.map((item, index) => (
                      <div key={index} style={{ whiteSpace: 'pre-line' }}>
                        {item[historyObjectKeysParticular[key]]}
                      </div>
                    ))}
                  
                  {histories.filter((item) => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]]).length === 0 && (
                    <div className="d--center text-muted" style={{}}>
                      <div
                        style={{
                          fontSize: '14px',
                          fontWeight: '300',
                          textAlign: 'left',
                          color: 'gray',
                        }}
                      >
                        {keyLabels[key] ? ` No ${keyLabels[key]} ` : 'No Data Available'}
                      </div>
                    </div>
                  )}
                </CAccordionBody>
              </CAccordionItem>
            )
          })} */}
                {!showDataIfNoteIsFollowUp && (
                  <CAccordion alwaysOpen className="d-flex flex-column gap-2">
                    {Object.entries(historyMapping).map(([key, label], index) => {
                      const histories = personalHistory[key] || []
                      
                      return (
                        <CAccordionItem className="border" itemKey={index} key={key}>
                          <CAccordionHeader>{label}</CAccordionHeader>
                          <CAccordionBody className="d-flex flex-column gap-3">
                            {histories.length > 0 ? (
                              histories
                                .filter((item) => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]])
                                .map((item, index) => (
                                  <div key={index} style={{ whiteSpace: 'pre-line' }}>
                                    {item[historyObjectKeysParticular[key]]}
                                  </div>
                                ))
                            ) : (
                              // Show "No Data Available" if no histories exist
                              <div className="d--center text-muted">
                                <div
                                  style={{
                                    fontSize: '14px',
                                    fontWeight: '300',
                                    textAlign: 'left',
                                    color: 'gray',
                                  }}
                                >
                                  No Data Available
                                </div>
                              </div>
                            )}
                            
                            {histories.length > 0 && 
                             histories.filter((item) => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]]).length === 0 && (
                              <div className="d--center text-muted">
                                <div
                                  style={{
                                    fontSize: '14px',
                                    fontWeight: '300',
                                    textAlign: 'left',
                                    color: 'gray',
                                  }}
                                >
                                  No Data Available
                                </div>
                              </div>
                            )}
                          </CAccordionBody>
                        </CAccordionItem>
                      )
                    })}
                  </CAccordion>
                )}
        </CAccordion>
      )}
      

      <ProviderPatientAllergies noteStructureRef={noteStructureRef} saveTreatsShell={saveTreatsShell} patientID={patientID} loading={loading} setLoading={setLoading} allergiesList={allergiesList} setAllergiesList={setAllergiesList} patientDBData={patientDBData} setPatientDBData={setPatientDBData} />
      <ProviderHistoryAddModalTest
        loggedUserProvider={loggedUserProvider}
        getPatientHistory={getPatientHistory}
        AddHistoryToggle={AddHistoryToggle}
        setHistories={setHistories}
        setAddHistoryToggle={setAddHistoryToggle}
        patientID={patientID}
        noteStructureRef={noteStructureRef}
        saveTreatsShell={saveTreatsShell}
        setPatientDBData={setPatientDBData}
      />
    </div>
  )
}

export default ProviderPatientHistoryTest
